import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { Button, Dialog, Form, Input, Toast } from 'antd-mobile';
import '@styles/components/tryOutDialog.less';
// getSmsCode
import { selectTryOutDialog, setTryOutDialog } from '@store/appSlice';
import { useAppDispatch } from '@hooks/reduxHooks';
import $http from '@/http';

interface TryOutForm {
  username?: string;
  phone?: string;
  email?: string;
  company?: string;
  product?: string;
  type?: number;
  code?: string;
}

const TryOutDialog = () => {
  const dispatch = useAppDispatch();
  const tryOutDialog = useSelector(selectTryOutDialog);
  const [step, setStep] = useState(1);
  const [loading, setLoading] = useState(false);
  const [codeTip, setCodeTip] = useState('获取验证码');
  const [count, setCount] = useState(0);
  const [form] = Form.useForm();

  const rules: FormRule<TryOutForm> = {
    username: [{ required: true, message: '姓名不能为空' }],
    phone: [
      { required: true, message: '手机号不能为空' },
      { pattern: /^1[3|4|5|7|8][0-9]{9}$/, message: '手机号格式不正确' },
    ],
    email: [{ required: true, message: '邮箱不能为空' }],
    company: [{ required: true, message: '公司不能为空' }],
    product: [{ required: true, message: '产品不能为空' }],
    code: [{ required: true, message: '验证码不能为空' }],
  };

  /**
   * 获取验证码
   */
  const getCode = () => {
    if (count) return;

    form.validateFields(['phone']).then((res) => {
      const phone = res['phone'] as string;

      let params: GetSmsCodeParams = {
        phone,
      };

      $http.post('api/Home/getsendMailYM', params).then(() => {
        setCount(60);
        Toast.show({
          icon: 'success',
          content: '验证码发送成功，请注意查收',
          position: 'top',
        });
      });
    });
  };

  // 倒计时
  useEffect(() => {
    if (count) {
      setTimeout(() => {
        setCount((prevState) => prevState - 1);
      }, 1000);
    } else {
    }
  }, [count]);

  // 倒计时提示
  useEffect(() => {
    if (count) {
      setCodeTip(`重新获取 ${count}S`);
    } else {
      setCodeTip('重新获取');
    }
  }, [count]);

  /**
   * 关闭弹窗
   */
  const closeDialog = () => {
    dispatch(setTryOutDialog(false));
  };

  /**
   * 申请试用
   * @param data
   */
  const applyTryOut = (data: TryOutForm) => {
    setLoading(true);
    data.type = 2;
    $http
      .post('api/Home/sendMail', data, {
        noAuth: true,
      })
      .then(() => {
        setStep(2);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const dialogContentJSX = (
    <div className={'content-wrap'}>
      <div className={'content'}>
        {step === 1 && (
          <div className={'step-one'}>
            <div className={'top'}>
              {/* <img className={'bg'} src={require('@images/common/sybg.png').default} alt="" /> */}
              <div className={'title'}>
                <div className={'title-style'}>申请试用</div>
                {/* <p className={'con-style'}>多种软件等您来学习</p> */}
              </div>
            </div>

            <Form
              form={form}
              className={'try-out-form'}
              footer={
                <Button block type="submit" color="danger" loading={loading}>
                  提交
                </Button>
              }
              onFinish={applyTryOut}
            >
              <Form.Item name={'username'} rules={rules.username}>
                <div className={'listflex'}>
                  <div className={'text-s'}>姓名：</div>
                  <Input placeholder={'请输入姓名'} />
                </div>
              </Form.Item>

              <Form.Item name={'phone'} rules={rules.phone}>
                <div className={'listflex'}>
                  <div className={'text-s'}>手机号：</div>
                  <Input placeholder={'请输入手机号'} />
                </div>
              </Form.Item>
              <Form.Item name={'code'} rules={rules.code}>
                <div className={'listflex'}>
                  <div className={'text-s'}>验证码：</div>
                  <Input placeholder={'验证码'} className={'inputwidth'} />
                  <span
                    onClick={getCode}
                    className={'flex ac jc f13'}
                    style={{
                      width: 140,
                      background: '#DEE1E7',
                      alignSelf: 'stretch',
                      borderRadius: 4,
                      marginLeft: 10,
                      color: count ? '#8B8C90' : '#006fff',
                    }}
                  >
                    {codeTip}
                  </span>
                </div>
              </Form.Item>
              <Form.Item name={'email'} rules={rules.email}>
                <div className={'listflex'}>
                  <div className={'text-s'}>邮箱：</div>
                  <Input placeholder={'请输入邮箱'} />
                </div>
              </Form.Item>

              <Form.Item name={'company'} rules={rules.company}>
                <div className={'listflex'}>
                  <div className={'text-s'}>公司：</div>
                  <Input placeholder={'请输入公司'} />
                </div>
              </Form.Item>

              <Form.Item name={'product'} rules={rules.product}>
                <div className={'listflex'}>
                  <div className={'text-s'}>产品：</div>
                  <Input placeholder={'请输入申请试用的产品名称'} />
                </div>
              </Form.Item>
            </Form>
          </div>
        )}

        {step === 2 && (
          <div className={'step-two'}>
            <div className={'top'}>
              <img className={'bg'} src={require('@images/common/sqsycg.png').default} alt="" />
              <div className={'check-circle'}>
                <img src={require('@images/common/checkCircle.png').default} alt="" />
              </div>
            </div>

            <div className={'tip'}>提交成功！</div>

            <div className={'contact'}>
              <img src={require('@images/common/wxCode1.png').default} alt="" />
              <span>可通过在线客服或企业微信查询申请进度。</span>
            </div>
          </div>
        )}
      </div>

      <div className={'close'}>
        <img src={require('@images/common/close2.png').default} onClick={closeDialog} alt="" />
      </div>
    </div>
  );

  return (
    <Dialog
      bodyClassName={'try-out-dialog'}
      content={dialogContentJSX}
      visible={tryOutDialog}
      onClose={closeDialog}
    />
  );
};

export default TryOutDialog;
